import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  padding: 24px 40px;
  background-color: ${(props) => props.theme.color.blue.lightBlue};
  color: ${(props) => props.theme.color.blue.default};
  font-size: 14px;
  line-height: 24px;
  margin: 30px -30px -30px -30px; // We should remove this as we refactor the modal to match new design

  ${mediaQuery('small')} and (min-height: 700px) {
    margin: 0;
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;

export const Badge = styled.div`
  background-color: ${(props) => props.theme.color.blue.default};
  color: ${(props) => props.theme.color.light.default};
  padding: 4px 16px;
  border-radius: 4px;
  display: inline-block;
  font-weight: 700;
`;

export const Text = styled.div`
  margin-top: 4px;
`;
